export const styles = {
  wheelContainer: {
    height: "70px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },

  searchTextField: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {},
    },
  },

  searchInput: {
    borderRadius: "4px",
    backgroundColor: "#F6F7F9",
    color: "#565556",
    height: "40px",
  },

  dropdownStyle: {
    width: "80px",
    height: "40px",
    borderRadius: "4px",
    border: "1px solid #123051",

    "& > fieldset": {
      border: "none",
    },
  },

  wheelComponentContainer: {
    height: "32px",
    width: "32px",
  },

  iconStyles: {
    height: "16px",
    width: "16px",
  },
};
